import React from "react";

const Separater = () => {
  return <div className="w-10"></div>;
};

export default Separater;
